export const TENANT_CODE = {
  GUARDIAN: "GUARDIAN",
  PNJ: "PNJ",
};
